export const SESSION_KEY = 'wsession'; //our session serverside
export const NO_SESSION_VALUE = '_______';
export const CONNECTION_KEY = 'wconnection';

export const PTN_APP_KEY = "A4785K54PR785";

//export const TEST_38AA_KEY = "38AAE7";

export const ENDPOINT_742_ = "wsu742"
export const ENDPOINT_755_ = "ws755"
export const ENDPOINT_848 = "ws848"
export const ENDPOINT_945 = "ws945"

export const WS_ON_APP = true

//export const QTMCMD_TIP_NU = "QtmCommand";
//export const IRMFCMD_TIP_NU = "IrmfCommand";
//export const ZCMD_TIP_NU = "ZakCommand";
export const TICK_PREFIX = 'new CustomEvent("tick"';
export const ACCESS_USERS = "accessuzers";
export const REMOVE_USER = "removeuzer"; //TODO change hide && show
export const ADD_USER = "adduzer";
export const ACTIVE_USERS = "activeuzers";
export const SPECIAL_USER = "s8654566";

export const KLOG = false; 

export const TICK_MESSAGE = 'document.dispatchEvent(new CustomEvent(\\"tick\\"';
export const TICK_KEY = 'new CustomEvent("tick"';
export const JOIN_CMD = "joinws"; 
export const QUIT_CMD = "quitws";
export const QUIT_KEY = "kquitws";
export const JOIN_KEY = "kjoinws";
export const NOT_EXIST_KEY = "not exists";
export const ALLREADY_EXIST_KEY = "allready exists";
export const INFORM_CMD = "inform";     
export const USERS_CMD = "users";
export const A8768_USER = "a8768";
export const INFORM_KEY1 = "kinformws";
export const CONNECTED_KEY = "connected";
export const THE_SERVER ="srv";
export const SERVER9647 = "server9647";
export const SERVER6527 = "server6527"
export const REQUEST_KEY = "request";
export const GATEWAY_SENDER = "wsgateway";
export const BM_MESSAGE = "BmMessage";
export const ALL_RECIPIENTS = "all";
export const LEGACY_SENDER = "wlegacy"; //old messages, should now be adapted
export const CMD986532_KEY = "cmd986532";
export const ACTION_KEY = "action";
export const TEXT_TYPE = "Text";

export const END_CONNECTION = "end_connection"
export const CMD876534_KEY = "cmd876534"
export const INIT_CONNECTION = "init_connection"
export const SESSIONS_LIST_CMD ="w643sessionlist"
export const WS_USERS_CONNECTED_KEY = "w876connected"
export const WS_SESSIONS_KEY = "w877sessions"


export const ACTION_CMD_ = "_action";
export const ACTION_WS = "_action_ws";

export const ACTION_REQUEST_HIVEDATASV2_nu = "_action_request_hivedatas";
export const ACTION_REQUEST_HIVEDATASV3 = "request_3_hivedatas";

export const REST_HIVEDATAS = "hive-data";

export const ACTION_PREFIX = "_action";
export const ACTION_HIVEDATAS_GUI_READY = "_action_hivedatas_gui_ready";
export const ACTION_INIT = "_action_init";
export const ACTION_REQUEST_RUNNING_ = "_action_request_running";

export const ACTION_CLICK_HIVEDATAS = "_action_click_hivedatas";

export const ACTION_TARE_HIVEDATAS = "_action_tare_hivedatas";
export const ACTION_CALIBP_HIVEDATAS = "_action_calibp_hivedatas";
export const ACTION_CALIBM_HIVEDATAS = "_action_calibm_hivedatas";
export const ACTION_IOT__HIVEDATAS = "_action_iot_hivedatas";
// export const ACTION_CALIBP_HIVEDATAS2 = "_action_calibp_hivedatas2";
// export const ACTION_CALIBM_HIVEDATAS2 = "_action_calibm_hivedatas2";

export const ACTION_PAGE_IOT_HIVEDATAS = "_action_page_iot_hivedatas";
export const ACTION_PAGE_PESON_HIVEDATAS = "_action_page_peson_hivedatas";
export const ACTION_PAGE_TUNING_HIVEDATAS = "_action_page_tuning_hivedatas";

export const ACTION_PAGE_MOCK_HIVEDATAS = "_action_page_mock_hivedatas";

export const ACTION_POST_HIVEDATAS = "_action_post_hivedatas";
export const ACTION_RECONCILE_HIVEDATAS_ = "_action_reconcile_hivedatas";

export const ACTION_TESTME = "_action_testme";

export const ACTION_PAGE_HOME_HIVEDATAS = "_action_page_home_hivedatas";

export const ACTION_GET_SSID = "_action_get_ssid";

export const ACTION_REQUEST_FRAGMENT = "_action_request_fragment";

export const CLASS_GREEN = "w3-button w3-ripple w3-green";
export const CLASS_YELLOW = "w3-button w3-ripple w3-yellow";
export const CLASS_RED = "w3-button w3-ripple w3-red";
export const CLASS_DISABLED = "w3-button w3-ripple w3-light-grey";// w3-sand";


/*

//"_action_request_hivedatas141000"
//"hd645345"

    private void requestHiveData_(String cmd) {
        String id = cmd.substring(WebConstants.ACTION_REQ_UEST_HIVEDATAS.length());
        int hdid = Integer.parseInt(id);
        HiveData h = hiveDataService.getHiveDataById(hdid);
        sendObject("HiveData", "hd645345", asString(h));
    }

export interface RequestObject{
    action: string;
    key: string;
    criterion: string;
}

Interface RequestObject{
  String action;
  String key;
  String criterion;
}

{
 action: "_action_request_hivedatas", //ACTION_REQ_UEST_HIVEDATAS
 key: "hd645345",
 criterion: "141000",
}
 
replace private void requestHiveData_(String cmd)  with:

    private void requestHiveData_(RequestObject ro) {
        String id = ro.getCriterion();
        int hdid = Integer.parseInt(id);
        HiveData h = hiveDataService.getHiveDataById(ro);
        sendObject("HiveData", ro.getKey(), asString(h));
    }

=====================

asis:
   private void requestHiveData_http(String cmd) {
        String id = cmd.substring(WebConstants.ACTION_REQUE_ST_HIVEDATAS.length());
        int hdid = Integer.parseInt(id);
        String url = "http://localhost:8098/api/hive-data/" + hdid;
        HiveData h = service_getRest(url);
        sendObject("HiveData", "hd645345", asString(h));
    }

tobe:
   private void requestHiveData_http(RequestObject ro) {
        String id = ro.getCriterion();
        int hdid = Integer.parseInt(id);
        String key = ro.getKey();
        String url = "http://localhost:8098/api/hive-data/" + hdid +"/"+key;
        HiveData h = service_getRest(url);
        sendObject("HiveData", key, asString(h));
    }

====================

replace function sendMessage(mesg: string, key:string)  with

function sendMessageR(mesg: string, req:RequestObject) {
  if (!checkConnection()){
    return;
  }
  const mesg = JSON.stringify(req);
  let m: WSSend = {
    content: mesg,
    key: key,
    sender: myid, //'adminz@adminz.com',//'adminz@adminz.com',//cuser.login,sender: 'adminz@adminz.com',//cuser.login,
    recipient: selectedUser_,
  };
  websocket.send(JSON.stringify(m));
}
*/

